import { Icon } from '@iconify/react';
import toast from 'react-hot-toast';
import { useMinistryTeamStore } from '../../../../../store/ministryTeamStore';
import { useDeleteMinistryTeam } from '../hooks/useDeleteMinistryTeam';
import { useIsReadOnly } from '../../../../../store/reportStore';
import styles from './MinistryTeamList.module.css';

export const MinistryTeamList = () => {
  const { ministryTeams } = useMinistryTeamStore();
  const { deleteMinistryTeam } = useDeleteMinistryTeam();
  const isReadOnly = useIsReadOnly();

  /**
   * 사역팀 삭제 핸들러
   */
  const handleDeleteMinistryTeam = (ministryTeam: (typeof ministryTeams)[0]) => {
    const confirmMessage = `${ministryTeam.name}\n\n정말 삭제하시겠습니까?`;

    if (window.confirm(confirmMessage)) {
      deleteMinistryTeam(ministryTeam.id as number)
        .then(() => toast.success('성공적으로 삭제했습니다'))
        .catch(() => toast.error('사역팀 삭제 중 오류가 발생했습니다. 다시 시도해주세요.'));
    }
  };

  return (
    <div className={`col-xs-12 col-sm-8 col-md-8 styled-text-group ${styles.listContainer}`}>
      {ministryTeams.map((ministryTeam, idx) => (
        <div className="styled-icon" key={idx}>
          <span className="seeker">{ministryTeam.name}</span>
          {!isReadOnly && <Icon icon="bi:x-circle-fill" onClick={() => handleDeleteMinistryTeam(ministryTeam)} className={styles.deleteIcon} color="rgba(153, 153, 153, 0.6)" />}
        </div>
      ))}
    </div>
  );
};
